import React from 'react';
import { useQuery, gql } from '@apollo/client';
import { Redirect, useParams } from 'react-router-dom';
import AuthenticationForm from './AuthenticationForm';

const IS_RESET_TOKEN_VALID = gql`
  query isResetTokenValid($resetToken: String!) {
    isResetTokenValid(resetToken: $resetToken)
  }
`;
const ResetTokenChecker = props => {
  let { resetToken } = useParams();
  // console.log(resetToken);

  const { data, loading } = useQuery(IS_RESET_TOKEN_VALID, {
    variables: { resetToken },
  });

  // console.log({ data, loading, error });

  if (loading) {
    return null;
  }

  if (!data.isResetTokenValid) {
    const errorUrl = `/authentication/confirm?type=resetTokenError`;
    return <Redirect to={errorUrl} />;
  }
  return <AuthenticationForm {...props} purpose="resetPassword" />;
};

export default ResetTokenChecker;
